import request from '@/tool/request'
let Base64 = require('js-base64').Base64;
import CryptoJS from 'crypto-js/crypto-js'
/**
 * 获取游戏
 */
export function gamelist() {
  return request({
    url: '/games',
    method: 'get',
    params:getobj({})
  })
}

/**
 * 获取礼包信息
 */
export function gamePackagesInfo(obj) {
  return request({
    url: '/packages',
    method: 'get',
    params: getobj(obj)
  })
}

/**
 * 获取游戏信息
 */
export function gameInfo(obj) {
  return request({
    url: '/game_config',
    method: 'post',
    data: getobj(obj)
  })
}

/**
 * 根据fpid获取角色信息
 */
export function checkfpid(obj) {
  return request({
    url: '/callback/check/fpid',
    method: 'post',
    data:getobj(obj)
  })
}
// patpal订单创建以及支付
export function getpaypalorder(obj) {
  return request({
    url: '/paypal/paypal_order',
    method: 'post',
    data:getobj(obj)
  })
}

export function paypal_callback(obj) {
  return request({
    url: '/paypal/paypal_capture',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * 创建支付宝或者微信预定单
 */
export function getReservationOrder(obj) {
  return request({
    url: '/provider_order',
    method: 'post',
    data: getobj(obj)
  })
}

/**
 * ayden创建预订单
 */
export function getorder(obj) {
  return request({
    url: '/callback/payment_methods',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * 去支付
 */
export function adyen_callback(obj) {
  return request({
    url: '/callback/adyen_callback',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * 去支付校验
 */
export function adyen_payments_details(obj) {
  return request({
    url: '/callback/adyen_payments_details',
    method: 'post',
    data:getobj(obj)
  })
}


/**
 * 获取账单凭证
 */
export function getinvoice(obj) {
  return request({
    url: '/callback/send/invoice',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * 检查列表次数接口
 */
export function packagesinfo(obj) {
  return request({
    url: '/packages/pay_info',
    method: 'get',
    params:getobj(obj)
  })
}


/**
 * 检查列表次数接口
 */
export function upcustomurl(obj) {
  return request({
    url: '/callback/custom_url',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * 获取session和短链
 */
export function getSession(obj) {
  return request({
    url: '/callback/user/get_session',
    method: 'post',
    data:getobj(obj)
  })
}

/**
 * session获取用户信息
 */
export function getUserInfoBySession(obj) {
  return request({
    url: '/callback/user/get_session_info',
    method: 'post',
    data:getobj(obj)
  })
}

//jiami
export function getobj(data){
    var obj = deepCopy(data);
    obj.ts = Math.floor(new Date().getTime()/1000);
    var str = objKeySort(obj);
    let sig = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(str,process.env.JUMP)) ;
    sig = Base64.encode(sig)
    obj.auth = sig;

    function objKeySort(obj) {
        var newkey = Object.keys(obj).sort();
    　　
        var newObj = '';
        for (var i = 0; i < newkey.length; i++) {
            //newObj[newkey[i]] = obj[newkey[i]];

            if(newObj == ''){
              newObj = newkey[i]+'='+obj[newkey[i]]
            }else{
              newObj = newObj +'&'+newkey[i]+'='+obj[newkey[i]]
            }
        }
        return newObj;
    }



    return obj;
}


function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  let copy = {};
  if (Array.isArray(obj)) {
    copy = [];
  }

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }

  return copy;
}

// /**
//  * 获取下拉项
//  */
// export function getchoices(url,modelid) {
//   var id = sessionStorage.getItem('endpoint_id')
//   return request({
//     url: '/op/endpoints/'+id+'/'+modelid+'/selection',
//     method: 'post',
//     data:{'select_url':url}
//   })
// }





// WEBPACK FOOTER //
// ./src/api/index.js